export class PaymentBuilder {
    constructor() {
        this.properties = {};
    }
    withType(paymentType) {
        this.properties.type = paymentType;
        return this;
    }
    withDuration(duration) {
        this.properties.months = duration;
        return this;
    }
    withDownPayment(downPayment) {
        this.properties.downPayment = downPayment;
        return this;
    }
    withResidualValue(residualValue) {
        this.properties.residualValue = residualValue;
        return this;
    }
    withExternalId(externalId) {
        this.properties.externalId = externalId;
        return this;
    }
    withCreditAssessment(creditAssessment) {
        this.properties.creditAssessment = creditAssessment;
        return this;
    }
    build() {
        return this.properties;
    }
}
